import getStore from '../store/store';

export default function isCheckPermPending(composeId: string): boolean {
    return getStore().permissionCheckers.has(composeId);
}
